module.exports = __webpack_public_path__ + "img/Luke-Skywalker-03-icon.6c1bb111.png";